import Home from "pages";
import Head from "next/head";

const CLM = () => {
  return (
    <>
      <Head>
        <title>BoloSign CLM - AI Contract Management & Smart eSignatures</title>
        <meta
          name="description"
          content="BoloSign Contract Lifecycle Management (CLM) streamlines your contract processes from creation to renewal. Automate workflows, manage templates, and gain insights with our all-in-one CLM solution."
        />
        <meta
          name="keywords"
          content="BoloSign CLM, Contract Lifecycle Management, contract automation, contract templates, contract workflows, contract management software, CLM solution"
        />
        <link rel="canonical" href="https://www.bolosign.com/clm/" />
      </Head>
      <Home />
    </>
  );
};

export default CLM;
